import React from "react";
import { List, Image, Spacer } from "../dynamic.components";
import sensors from "src/assets/images/process_control/sensors.png";
import SubHotspots from "../Sub-hotspots";

export const ConductivieySub = () => (
  <>
    <Spacer />
    <List
      listArray={[
        "Conductivity and temperature sensors are located on the retentate and permeate section. These sensors are used to monitor and control the process, for example as an end point control during a diafiltration step, to achieve stable conductivity values during equilibration.",
      ]}
    />
    <Spacer />
  </>
);
export const PressureSub = () => (
  <>
    <Spacer />
    <List
      listArray={[
        "Pressure sensors are located after the feed pump in the feed section, post filter on the retentate section and on the permeate section. Pressure sensors are used to control and monitor filtration processes, for example to achieve transmembrane pressure (TMP) or delta P (differential pressure between feed and retentate).",
      ]}
    />
    <Spacer />
  </>
);
export const FlowMeterSub = () => (
  <>
    <Spacer />
    <List
      listArray={[
        "Flow meter is located on the permeate section. Flow meter is used to measure permeate flow rate, monitor and control permeate flux. Retentate flow is a measured value of difference between feed flow and permeate flow.",
      ]}
    />
    <Spacer />
  </>
);
export const UvSensorSub = () => (
  <>
    <Spacer />
    <List
      listArray={[
        "UV sensor is located on the permeate section after the permeate pump. UV sensor is used for measuring protein absorbance values to monitor and control TFF process.",
      ]}
    />
    <Spacer />
  </>
);
export const PhSensorSub = () => (
  <>
    <Spacer />
    <List
      listArray={[
        "pH sensor is located on the permeate section. pH is used for monitoring and controlling filtration process for an e.g, during equilibration, post cleaning to ensure cleaning agents are washed out, during diafiltration when buffer exchange will happen.",
      ]}
    />
    <Spacer />
  </>
);
export const Sensors: React.FC = (): JSX.Element => {
  return (
    <>
      <div className="c-sidebar__body">
        <SubHotspots sublinkId="4-3" buttonWidth="large" />
        <Image
          images={[
            {
              src: sensors,
              alt: "Sensors image",
              customWidth: "70%",
            },
          ]}
        />
      </div>
    </>
  );
};
